import { Box, Button, Divider, Flex, RadioGroup } from "@chakra-ui/react";
import { useFormikContext } from "formik";
import { FunctionComponent, useCallback } from "react";
import { FormAddress } from "src/schemas/Address";
import {
  SuggestedAddressRadioOption,
  SuggestedAddressType,
} from "./SuggestedAddressRadioOption";

type FormikAddressSuggestionFormProps = {
  originalAddress: FormAddress;
  suggestedAddress: FormAddress;
};

export const PickSuggestedAddress: FunctionComponent<
  FormikAddressSuggestionFormProps
> = (props) => {
  const { originalAddress, suggestedAddress } = props;
  const { setValues, submitForm } = useFormikContext<FormAddress>();

  const setNewAddress = useCallback(
    (radioValue: SuggestedAddressType) => {
      if (radioValue === SuggestedAddressType.Original) {
        setValues(originalAddress);
      }

      if (radioValue === SuggestedAddressType.Suggested) {
        setValues(suggestedAddress);
      }
    },
    [setValues, originalAddress, suggestedAddress]
  );

  return (
    <RadioGroup onChange={setNewAddress} defaultValue="original">
      <Flex direction="column">
        <SuggestedAddressRadioOption
          type={SuggestedAddressType.Original}
          address={originalAddress}
        />
        <Divider />
        <SuggestedAddressRadioOption
          type={SuggestedAddressType.Suggested}
          address={suggestedAddress}
        />
        <Divider />
        <Box padding={4}>
          <Button
            colorScheme="primary"
            variant="outline"
            width="100%"
            onClick={submitForm}
          >
            Save address
          </Button>
        </Box>
      </Flex>
    </RadioGroup>
  );
};
